
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'basic-card-action',
  props: {
    title: String,
    noInlineBorder: {
      type: Boolean,
      default: false
    },
    explicitContainment: {
      type: Boolean,
      default: false
    },
    action: String
  }
})
